import { render, staticRenderFns } from "./importPeriodo.vue?vue&type=template&id=dea2360e"
import script from "./importPeriodo.vue?vue&type=script&lang=js"
export * from "./importPeriodo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports